import {
  LicenseMonitoringData,
  LicenseMonitoringResponse,
  LicenseMonitoringSmartFilters,
} from 'features/workflow-module/components/license-monitoring/license-monitoring.interface';
import { SmartTable } from '@certemy/ui-components';
import { COLUMN_TYPE } from 'constants/status.constants';
import _isNil from 'lodash-es/isNil';

export const DefaultTableData: LicenseMonitoringResponse = {
  rows: [],
  count: 0,
};

export enum QUEUE_VALUE {
  'initial-review' = 1,
  'final-review' = 2,
  'history' = 3,
}

export enum TITLE_VALUE {
  'Initial Review' = 1,
  'Final Review' = 2,
  'History' = 3,
}

export const DEFAULT_SMART_FILTERS_VALUES: LicenseMonitoringSmartFilters = {
  diffScoreMin: null,
  severity: [],
};

export const DefaultHeaders: SmartTable.Header[] = [
  { name: 'Priority', value: 'priority', type: COLUMN_TYPE.STATUS_COLOR },
  { name: 'Source Name', value: 'sourceName', type: SmartTable.ColumnTypeId.STRING, sortable: true },
  { name: 'Differential Score', value: 'diffScore', type: SmartTable.ColumnTypeId.STRING, sortable: true },
  {
    name: 'Severity',
    propertyName: 'classification',
    value: (row: LicenseMonitoringData) =>
      _isNil(row.classification) ? row.classification : SEVERITY_VALUES[row.classification],
    type: SmartTable.ColumnTypeId.CUSTOM,
    sortable: true,
  },
  { name: 'Create Date', value: 'rcd', type: SmartTable.ColumnTypeId.DATE, sortable: true },
  { name: 'Subscription Count', value: 'subscriptionCount', type: SmartTable.ColumnTypeId.STRING, sortable: true },
  {
    name: 'Last Worked By',
    propertyName: 'lastWorkedBy',
    value: (row: LicenseMonitoringData) =>
      row.reportLastUpdatedBy && `${row.reportEditedByFirstName} ${row.reportEditedByLastName}`,
    type: SmartTable.ColumnTypeId.CUSTOM,
    sortable: true,
  },
  {
    name: 'First Reviewer',
    propertyName: 'firstReviewer',
    value: (row: LicenseMonitoringData) =>
      row.firstReviewerId && `${row.firstReviewerFirstName} ${row.firstReviewerLastName}`,
    type: SmartTable.ColumnTypeId.CUSTOM,
    sortable: true,
  },
  {
    name: 'Final Reviewer',
    propertyName: 'finalReviewer',
    value: (row: LicenseMonitoringData) =>
      row.finalReviewerId && `${row.finalReviewerFirstName} ${row.finalReviewerLastName}`,
    type: SmartTable.ColumnTypeId.CUSTOM,
    sortable: true,
  },
];

export const AdditionalHeaders = {
  checkType: { name: '', value: 'selected', type: SmartTable.ColumnTypeId.CHECK },
};

export const DefaultFilter = {
  filters: { queue: QUEUE_VALUE['firstReview'] },
  orderId: 'rcd',
  orderType: SmartTable.Order.DESC,
  offset: 0,
  limit: 10,
  search: '',
};

export const SeverityOptions = [
  { id: '0', name: 'No Change' },
  { id: '1', name: 'Minor Change' },
  { id: '2', name: 'Major Change' },
  { id: '3', name: 'Critical Change' },
];

export const LicenseMonitoringTabs = [
  {
    display: 'INITIAL REVIEW',
    link: 'initial-review',
  },
  {
    display: 'FINAL REVIEW',
    link: 'final-review',
  },
  {
    display: 'HISTORY',
    link: 'history',
  },
];

export enum SEVERITY_VALUES {
  'No Change' = 0,
  'Minor Change' = 1,
  'Major Change' = 2,
  'Critical Change' = 3,
}
